// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1f_dF","itemTitle":"ClientEmergencyInfo_itemTitle__2Nryl","itemText":"ClientEmergencyInfo_itemText__3Mm0t"};